import { useState, useEffect } from 'react';
import { useVideoControlContext } from '../contexts/VideoControlContext';
export const useVideoControlButton = () => {
    const { togglePlayPause, isPlaying, hasVideo } = useVideoControlContext();
    const [playing, setPlaying] = useState(true);
    useEffect(() => {
        if (!hasVideo)
            return;
        const interval = setInterval(() => {
            setPlaying(isPlaying());
        }, 100);
        return () => clearInterval(interval);
    }, [isPlaying, hasVideo]);
    const handlePlayPauseClick = () => {
        if (!hasVideo)
            return;
        togglePlayPause();
        setPlaying(!playing);
    };
    return {
        playing,
        handlePlayPauseClick,
        shouldShowButton: hasVideo
    };
};
